import _, { round } from 'lodash'
import parse from 'parse-duration'
import { EquityPattern } from '@/plugins/payment'
import { isInfinite, INFINITE_TEXT } from '@/plugins/balance'

export function formatDuration(seconds) {
  if (_.isNil(seconds)) {
    return null
  }
  let s = seconds % 60
  let m = Math.floor(seconds / 60) % 60
  let h = Math.floor(seconds / (60 * 60)) % 24
  let d = Math.floor(seconds / (60 * 60 * 24))
  let ret = ''
  if (d > 0) {
    ret += `${d}d`
  }
  if (h > 0) {
    ret += `${h}h`
  }
  if (m > 0) {
    ret += `${m}m`
  }
  if (s > 0) {
    ret += `${s}s`
  }
  if (ret.length <= 0) {
    ret = '0s'
  }
  return ret
}

export function parseDuration(text) {
  if (_.isEmpty(text)) {
    return null
  }
  return round(parse(text, 'ms') / 1000)
}

export function formatAmount({ pattern, amount }) {
  if (isInfinite(amount)) {
    return INFINITE_TEXT
  }
  if (pattern === EquityPattern.SUBSCRIPTION || pattern === EquityPattern.PROMOTER) {
    return formatDuration(amount)
  } else {
    return amount
  }
}
